//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import empty from '../empty.vue';
export default {
  name: 'saas_long_image',
  components: {
    empty: empty
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    moduleList: function moduleList() {
      if (this.value.config.data_source_type === 2) {
        return this.value.config.value || [];
      }
      return this.value.default_value || [];
    }
  }
};